"use client";
import React from "react";
import { motion } from "framer-motion";
import Header from "../Header";
import HeroAboutSection from "./HeroAboutSection";
import ServicesAboutSection from "./ServicesAboutSection";
import StorySection from "./StorySection";
import StandardsSection from "./StandardsSection";
import Footer from "../Footer";
import { useEffect } from "react";

const AboutPage = () => {
    useEffect(() => {
      window.scrollTo(0, 0);
    }, []);
  return (
    <motion.div
      className=""
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.8 }}
    >
      <div className="overflow-hidden bg-white">
        <Header />
        <div className="flex flex-col w-full">
          <HeroAboutSection />
          <ServicesAboutSection />
          <StorySection />
          <StandardsSection />
          <Footer />
        </div>
      </div>
    </motion.div>
  );
};

export default AboutPage;
